export const sanitizeUserForStorage = user => {
  if (!user) return user;

  const persistedUser = { ...user };
  delete persistedUser.refreshToken;
  if (process.env.NODE_ENV !== 'development') {
    delete persistedUser.authToken;
  }
  return persistedUser;
};

export const getStoredUser = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    const sanitizedUser = sanitizeUserForStorage(user);
    if (sanitizedUser) {
      localStorage.setItem('user', JSON.stringify(sanitizedUser));
    }
    return sanitizedUser;
  } catch (error) {
    localStorage.removeItem('user');
    return null;
  }
};

export const storeUser = user => {
  const sanitizedUser = sanitizeUserForStorage(user);
  if (sanitizedUser) {
    localStorage.setItem('user', JSON.stringify(sanitizedUser));
  } else {
    localStorage.removeItem('user');
  }
};
